import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private readonly _isDark = signal(this.readPreference());
  readonly isDark = this._isDark.asReadonly();

  constructor() {
    if (this.isBrowser) this.apply(this._isDark());
  }

  toggle(): void {
    const next = !this._isDark();
    this._isDark.set(next);
    if (!this.isBrowser) return;
    this.apply(next);
    localStorage.setItem('ds-theme', next ? 'dark' : 'light');
  }

  private readPreference(): boolean {
    if (!this.isBrowser) return false;

    const stored = localStorage.getItem('ds-theme');
    if (stored) return stored === 'dark';

    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  }

  private apply(dark: boolean): void {
    document.documentElement.classList.toggle('dark', dark);
  }
}
